import OverviewRoute from "@/routes/processes/[processId]/vbs/overview/overview";
import ContactRoute from "@/routes/processes/[processId]/vbs/contact/contact";
import { Navigate, Outlet, RouteObject } from "react-router";
import { WorkOrdersRoute } from "@/routes/processes/[processId]/vbs/work-orders/work-orders-route";
import { calculationsRoutes } from "@/routes/processes/[processId]/vbs/calculations/calculations-routes";
import { vbsOffersRoutes } from "@/routes/processes/[processId]/vbs/offers/offers-routes";
import { confirmationsRoutes } from "@/routes/processes/[processId]/vbs/confirmations/confirmations-routes";
import { workOrdersRoutes } from "@/routes/processes/[processId]/vbs/work-orders/work-orders-routes";
import { certificatesRoutes } from "@/routes/processes/[processId]/vbs/certificates/certificates-routes";
import { vbsOrdersRoutes } from "@/routes/processes/[processId]/vbs/orders/orders-routes";
import { commitmentsRoutes } from "@/routes/processes/[processId]/vbs/commitments/commitments-routes";
import { ProcessConfiguredGuard } from "../_components/process-configured-guard";

export const vbsRoutes: RouteObject[] = [
  {
    element: <Navigate to="overview" replace />,
    index: true,
  },
  {
    path: "overview",
    element: <OverviewRoute />,
  },
  {
    path: "contact",
    element: <ContactRoute />,
  },
  // The following routes require a fully coanfigured process.
  // The elements are wrapped with an appropriate guard, to
  // notify the user.
  ...[
    {
      path: "calculations",
      element: <Outlet />,
      children: calculationsRoutes,
    },
    {
      path: "commitments",
      element: <Outlet />,
      children: commitmentsRoutes,
    },
    {
      path: "offers",
      element: <Outlet />,
      children: vbsOffersRoutes,
    },
    {
      path: "orders",
      element: <Outlet />,
      children: vbsOrdersRoutes,
    },
    {
      path: "confirmations",
      element: <Outlet />,
      children: confirmationsRoutes,
    },
    {
      path: "work-orders",
      element: <WorkOrdersRoute />,
      children: workOrdersRoutes,
    },
    {
      path: "certificates",
      element: <Outlet />,
      children: certificatesRoutes,
    },
  ].map((route) => ({
    ...route,
    element: <ProcessConfiguredGuard>{route.element}</ProcessConfiguredGuard>,
  })),
];
